import { PublicShopQuery } from '@water-web/api';

export const PublicShopConstructor = (apiUrl: string) => ({
  byId: new PublicShopQuery(apiUrl),
});
